
import { Auth } from "../../services/Auth";
import store from '../../index';

export const PlayerVerificationEnum = {
    Email: 1,
    Mobile: 2,
    Address: 4,
    Identity: 8,
    Physical: 16,
    Citizenship: 32,
    CPF: 64,
    Document: 128,
}

export const PlayerVerificationKeys = {
    [PlayerVerificationEnum.Email]: 'email',
    [PlayerVerificationEnum.Mobile]: 'phoneNumber',
    [PlayerVerificationEnum.Address]: 'address',
    [PlayerVerificationEnum.Identity]: 'identity',
    [PlayerVerificationEnum.Physical]: 'physicalVerify',
    [PlayerVerificationEnum.Citizenship]: 'citizenship',
    [PlayerVerificationEnum.CPF]: 'cpfNumber',
    [PlayerVerificationEnum.Document]: 'document',
}

const PlayerVerificationHelper = {
    getUnVerifiedFilds: (playerData) => {
        if (!Auth.isAuthenticated() || !playerData) return []
        const { brandVerification = [] } = store.getState().settings;
        const { isMobileNumberVerified, isEmailVerified, isDocumentVerified, isPhysicalVerified, isCitizenshipVerified, isAddressVerified, isIdentityVerified, isCpfNumberVerified } = playerData;
        let verifiedData = [];
        !isMobileNumberVerified && verifiedData.push(PlayerVerificationEnum.Mobile);
        !isEmailVerified && verifiedData.push(PlayerVerificationEnum.Email);
        !isDocumentVerified && verifiedData.push(PlayerVerificationEnum.Document);
        !isPhysicalVerified && verifiedData.push(PlayerVerificationEnum.Physical);
        !isCitizenshipVerified && verifiedData.push(PlayerVerificationEnum.Citizenship);
        !isAddressVerified && verifiedData.push(PlayerVerificationEnum.Address);
        !isIdentityVerified && verifiedData.push(PlayerVerificationEnum.Identity);
        !isCpfNumberVerified && verifiedData.push(PlayerVerificationEnum.CPF);
        verifiedData.length === 0 && verifiedData.push(0);

        return brandVerification.filter(item => verifiedData.includes(item)).map(i => PlayerVerificationKeys[i]);
    }
}

export default PlayerVerificationHelper;